import { Component, For } from 'solid-js';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

/**
 * TableSkeleton Component
 * Displays animated skeleton loaders in table format
 * Used as loading placeholder while data is being fetched
 */
const TableSkeleton: Component<TableSkeletonProps> = (props) => {
  const rows = props.rows || 5;
  const columns = props.columns || 7;

  return (
    <div class="space-y-3">
      {/* Header skeleton */}
      <div class="grid gap-2 md:gap-4" style={{ 'grid-template-columns': `repeat(${columns}, minmax(0, 1fr))` }}>
        <For each={Array.from({ length: columns })}>
          {() => (
            <div class="h-6 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
          )}
        </For>
      </div>

      {/* Row skeletons */}
      <For each={Array.from({ length: rows })}>
        {() => (
          <div class="grid gap-2 md:gap-4" style={{ 'grid-template-columns': `repeat(${columns}, minmax(0, 1fr))` }}>
            <For each={Array.from({ length: columns })}>
              {() => (
                <div class="h-5 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
              )}
            </For>
          </div>
        )}
      </For>
    </div>
  );
};

export default TableSkeleton;
